import { render, staticRenderFns } from "./SddfFileUploader.vue?vue&type=template&id=fdd4807c&scoped=true&"
import script from "./SddfFileUploader.vue?vue&type=script&lang=js&"
export * from "./SddfFileUploader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fdd4807c",
  null
  
)

export default component.exports